import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

const Header = ({ question }) => {
    return (
        <Container fluid className='bg-head'>
            <Row className={'text-center pt-4 ques-txt'}>
                <Col className='align-self-center'>{question}</Col>
            </Row>
            <Row className={'justify-content-center'}>
                <div className='arrown-tilt'></div>
            </Row>
        </Container>
    );
};

export default Header;
